import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "@/pages/payment-methods/Columns"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import AddContactModal from "./Model"
import { CrudProvider, useCrudContext } from "@/context/crudContext"

export default function PaymentMethodsList() {
  const breadcrumbs = [
    { label: "Dashboard", url: "/pos/dashboard" },
    { label: "Payment Methods" },
  ]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Payment Methods</h5>
      </div>

      <CrudProvider>
        <PaymentMethodTable />
      </CrudProvider>
    </>
  )
}

function PaymentMethodTable() {
  const { openDialog } = useCrudContext()

  return (
    <>
      <CustomTable
        label="Payment Methods"
        columns={columns}
        apiPath="settings"
        hardcodedFilters={{ key: "payment" }}
        revalidateQuery="payment"
      />

      {openDialog ? <AddContactModal /> : null}
    </>
  )
}
